<af-main-container [title]="organizationName"
                   [customLastBreadcrumb]="organizationName"
                   [buttonLabel]="hasReportAccess && ('i18n_af_buttonDownloadReport' | translate)"
                   (buttonClickListener)="downloadReport()"
                   [tabPathToTab]="tabPathToTab"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">

    <div CustomTitle class="w-100 mr-16 ml-16" fxLayout="row" fxLayoutAlign="end center" fxFlex>
        @if (hasReportAccess && (fraudReport && !fraudReport.signedAndSentDate)) {
            <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_send"
                        [matTooltip]="'i18n_af_buttonSignAndSend' | translate"
                        (click)="openSignDialog()"/>

            <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_refresh"
                        [matTooltip]="'i18n_af_buttonRegenerate' | translate"
                        (click)="openRegenerateReportDialog()"/>
        }
    </div>
    <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxFlex>
        @if (fraudReport) {
            <mat-tab-group
                mat-align-tabs="start"
                animationDuration="0"
                fxFlex
                class="mt-16 w-100 h-100 overflow-y-scroll small-text"
                [(selectedIndex)]="selectedTabIndex"
                (selectedIndexChange)="handleNavigation($event)">
                @for (tab of tabs; track tab) {
                    <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                        @if (tab !== 'tabHistory') {
                            <ng-template matTabLabel>
                                <label [matTooltip]="'i18n_af_tooltip_' + tab | translate" style="cursor: pointer">{{ 'i18n_af_' + tab | translate }}</label>
                            </ng-template>
                        }
                        <ng-template matTabContent>
                            @if (activeTab === tab) {
                                @if (tab === ('tab-' + reportSection)) {
                                    <af-fraud-report-data-tab
                                        [fraudReport]="fraudReport"
                                        [transactionTypes]="transactionTypes"
                                        [transactionCategories]="transactionCategories"
                                        [transactionStatuses]="transactionStatuses"
                                        [currencies]="currencies"
                                        [refundTypes]="refundTypes"
                                        [refundStatuses]="refundStatuses"
                                        [reportSection]="reportSection"
                                        />
                                }
                                @if (tab === 'tabFraudReportFiles') {
                                    <af-fraud-report-file-tab [fraudReport]="fraudReport" />
                                }
                                @if (tab === 'tabHistory') {
                                    <af-entity-history [entityId]="fraudReportId" [entityType]="EntityType.FRAUD_REPORT" mode="full"/>
                                }
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </div>
</af-main-container>
